// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__RSiVl","error":"Textarea_error__3tHEP","readonly":"Textarea_readonly__1MmkT","disabled":"Textarea_disabled__3wABg"};